var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconResponsive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "responsive 1",
    clipPath: "url(#clip0_0_28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.28412 12.4971C7.55859 12.7718 8.00391 12.7718 8.27838 12.4971L11.0909 9.68463C11.3655 9.41016 11.3655 8.96503 11.0909 8.69037C10.8164 8.41571 10.3713 8.41571 10.0966 8.69037L7.78125 11.0056L6.87213 10.0966C6.59766 9.82196 6.15234 9.82196 5.87787 10.0966C5.60321 10.3711 5.60321 10.8162 5.87787 11.0909L7.28412 12.4971Z",
    fill: "var(--fill-0, #0A0A0A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7685 15.3096L17.1747 16.7159C17.4492 16.9905 17.8945 16.9905 18.169 16.7159L20.9815 13.9034C21.2562 13.6289 21.2562 13.1838 20.9815 12.9091C20.707 12.6345 20.2619 12.6345 19.9872 12.9091L17.6719 15.2243L16.7628 14.3154C16.4883 14.0407 16.043 14.0407 15.7685 14.3154C15.4938 14.5898 15.4938 15.0352 15.7685 15.3096Z",
    fill: "var(--fill-0, #0A0A0A)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.10938 21.1875H12.75V21.8906C12.75 23.0537 13.6963 24 14.8594 24H21.8906C23.0537 24 24 23.0537 24 21.8906V7.78125C24 6.61816 23.0537 5.67188 21.8906 5.67188H16.9688V2.10938C16.9688 0.946289 16.0225 0 14.8594 0H2.10938C0.946289 0 0 0.946289 0 2.10938V19.0781C0 20.2412 0.946289 21.1875 2.10938 21.1875ZM1.40625 19.0781V18.3281H12.75V19.7812H2.10938C1.72174 19.7812 1.40625 19.4658 1.40625 19.0781ZM22.5938 19.7812H14.1562V9.89062H22.5938V19.7812ZM21.8906 22.5938H14.8594C14.4717 22.5938 14.1562 22.2783 14.1562 21.8906V21.1875H22.5938V21.8906C22.5938 22.2783 22.2783 22.5938 21.8906 22.5938ZM22.5938 7.78125V8.48438H14.1562V7.78125C14.1562 7.39362 14.4717 7.07812 14.8594 7.07812H21.8906C22.2783 7.07812 22.5938 7.39362 22.5938 7.78125ZM2.10938 1.40625H14.8594C15.247 1.40625 15.5625 1.72174 15.5625 2.10938V5.67188H14.8594C13.6963 5.67188 12.75 6.61816 12.75 7.78125V16.9219H1.40625V2.10938C1.40625 1.72174 1.72174 1.40625 2.10938 1.40625Z",
    fill: "var(--fill-0, #0A0A0A)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResponsive);
export default __webpack_public_path__ + "static/media/icon-responsive.a7e4dd95318dbe4349530590eb356d5e.svg";
export { ForwardRef as ReactComponent };